
import { Component, Prop, Vue } from 'nuxt-property-decorator'
import { Youtube } from 'vue-youtube'
import { GameEvent } from './model/GameEvent'
import { WebPlayer } from '~/api'

@Component({
  components: {
    Youtube,
  },
})
export default class WebPlayerYoutube extends Vue {
  @Prop() video!: GameEvent
  @Prop() platformSettings!: WebPlayer
  @Prop() isFullScreen!: boolean

  get playerVars(): Object {
    return {
      start: 0, //  Start time
      autoplay: this.video.params.autoplay ? 1 : 0, // Autoplay video upon loading
      controls: this.video.params.controls ? 1 : 0, // Show video controls
      autohide: 1, // Auto hide controls
      disablekb: 1, // disable keyboard
      iv_load_policy: 3, // Video annotations
      rel: 0, // Related videos
      // color : red, // Color of the video controls
    }
  }

  get thumbnail() {
    return `https://img.youtube.com/vi/${this.video.params.videoId}/mqdefault.jpg`
  }
}
